<template>
  <div class="box">
    <div class="money">
      <span>您有{{ refundTicketList.length }}笔退款，退款总金额</span>
      <div class="moneynum">
        <em>￥</em>
        <span>{{ totalPrice.toFixed(2) }}</span>
      </div>
    </div>
    <ul>
      <li v-for="item in refundTicketList" :key="item.itemId">
        <div class="top">
          <div class="detail">
            <div>
              <span>退款单</span><span>{{ item.id }}</span>
            </div>
            <div class="refundAmount">
              <span>退款金额</span>
              <div>
                <em>￥</em><span>{{ item.refundAmount }}</span>
              </div>
            </div>
          </div>
          <div class="stateText">
            <span>退票状态：{{ item.ticketStatusName }}</span>
          </div>
          <div class="stateText">
            <span>退款状态：{{ item.payStatusName }}</span>
            <div v-if="!item.switchState" @click="clickSwitch(item)">展开</div>
            <div class="rotate" v-else @click="clickSwitch(item)">关闭</div>
          </div>
        </div>
        <div class="bottom" v-if="item.switchState && item.payStatus === '1'">
          <div class="title">申请中</div>
          <div class="diagram success">
            <i></i>
            <div class="msg">
              <h6>发起退款</h6>
              <time>申请时间：{{ $dayjs(item.refundPayTime).format('YYYY-MM-DD HH:mm:ss') }}</time>
            </div>
            <div class="msg">
              <h6>申请中</h6>
              <div>已发起申请，请等候系统检验通过</div>
            </div>
          </div>
        </div>
        <div class="bottom" v-if="item.switchState && item.payStatus === '2'">
          <div class="title">退款成功</div>
          <div class="diagram apply">
            <i></i>
            <div class="msg">
              <h6>发起退款</h6>
              <time>申请时间：{{ $dayjs(item.refundPayTime).format('YYYY-MM-DD HH:mm:ss') }}</time>
            </div>
            <div class="msg">
              <h6>退款成功</h6>
              <time>退款时间：{{ $dayjs(item.refundDoneTime).format('YYYY-MM-DD HH:mm:ss') }}</time>
            </div>
          </div>
        </div>
        <div class="bottom" v-if="item.switchState && item.payStatus === '3'">
          <div class="title">退款失败</div>
          <div class="diagram fail">
            <i></i>
            <div class="msg">
              <h6>发起退款</h6>
              <time>申请时间：{{ $dayjs(item.refundPayTime).format('YYYY-MM-DD HH:mm:ss') }}</time>
            </div>

            <div class="msg">
              <h6>退款失败</h6>
              <div>描述：{{ item.comment }}</div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { individualOrderRefund } from "@/service/refund/touristRefundList.js";
export default {
  name: "hmtRefundDetails",
  data() {
    return {
      totalPrice: 0,
      refundTicketList: []
    };
  },
  created() {
    this.statusQuery();
  },
  methods: {
    async statusQuery() {
      const { data } = await individualOrderRefund.call(this, {
        orderId: this.$route.query.orderId
      });
      data.forEach(v => {
        v.switchState = false;
        this.totalPrice += Number(v.refundAmount);
      });
      this.refundTicketList = data;
    },
    clickSwitch(item){
      item.switchState = !item.switchState;
    }
  },
};
</script>

<style scoped lang='less'>
.box {
  padding: 0.226667rem * 2 0.346667rem 0;
  min-height: 100vh;
  .money {
    background: #ffffff;
    border-radius: 0.16rem;
    display: flex;
    justify-content: space-between;
    line-height: 1.333333rem;
    padding: 0 0.32rem;
    font-size: 0.213333rem * 2;
    .moneynum {
      color: #fe5339;
      font-weight: bold;
    }
    em {
      font-size: 0.146667rem * 2;
    }
  }
  ul {
    li {
      font-size: 0.426667rem;
      & > div{
        line-height: 0.586667rem;
        border-radius: 0.16rem;
        padding: 0.32rem;
        background: #ffffff;
        margin-top: 0.266667rem;
      }
    }
    .top {
      .detail {
        & > div:first-child span {
          margin-right: 0.346667rem;
        }
        .refundAmount {
          display: flex;
          margin-top: 0.266667rem;
          & > span {
            margin-right: 0.346667rem;
          }
          & > div {
            color: #fe5339;
            em {
              font-size: 0.146667rem * 2;
            }
          }
        }
      }
      .stateText {
        margin-top: 0.266667rem;
        color: #222328;
        font-size: 0.24rem * 2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
          font-weight: bold;
        }
        div{
          border: 1px solid #3B6D9C;
          border-radius: .08rem;
          line-height: .293333rem * 2;
          width: .853333rem * 2;
          font-size: .32rem;
          color: #3B6D9C;
          position: relative;
          padding: 0.05rem 0 0 0.32rem;
          &::after{
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-top: .053333rem * 2 solid transparent;
            border-right: .053333rem * 2 solid transparent;
            border-bottom: .053333rem * 2 solid transparent;
            border-left: .08rem * 2 solid #3B6D9C;
            right: .293333rem;
            top: 50%;
            transform: translate(50%, -50%);
          }
        }
        .rotate{
          &::after{
            transform: translate(25%, -25%) rotate(90deg);
          }
        }
      }
    }
    .bottom {
      height: 8rem;
      & > .title{
        color: #222328;
        font-size: .24rem * 2;
        font-weight: bold;
      };
      .diagram{
        padding-left: 1.066667rem;
        line-height: 1;
        margin-top: .533333rem;
        color: #A1A6BA;
        position: relative;
        i{
          position: absolute;
          width: .053333rem;
          height: 1.28rem * 2;
          left: .266667rem + (.426667rem / 2);
          top: .066667rem + .426667rem;
          transform: translateX(-50%);
          &::before{
            content: '';
            position: absolute;
            width: .213333rem;
            height: .213333rem;
            border-radius: 50%;
            top: 1.28rem * 2;
            left: 0;
            transform: translate(-40%, -25%);
          }
          &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: .053333rem;
            height: 1.413333rem;
          }
        }
        &::before{
          content: '';
          position: absolute;
          left: .266667rem;
          top: .066667rem;
          width: .426667rem;
          height: .426667rem;
          border-radius: 50%;
          box-sizing: border-box;
        }
        .msg{
          font-size: .213333rem * 2;
          &:last-child{
            margin-top: 1.333333rem;
          }
          h6{
            margin-bottom: .266667rem;
          }
          time,
          div{
            font-size: .32rem;
            margin-top: .266667rem;
          }
        }
      }
      .apply{
        h6{
          color: #3B6D9C;
        }
        i{
          background: rgba(59, 167, 97, .4);
          &::before{
            background: #3B6D9C;
          }
          &::after{
            background: #3B6D9C;
            height: 2.56rem;
          }
        }
        &::before{
          border:.106667rem solid #3B6D9C;
        }
      }
      .success{
        h6{
          color: #eabe30;
        }
        i{
          background: rgba(234, 190, 48, .4);
          &::before{
            background: rgba(234, 190, 48, .4);
          }
          &::after{
            background: #eabe30;
          }
        }
        &::before{
          border:.106667rem solid #eabe30;
        }
      }
      .fail{
        h6{
          color: #ff2d2b;
        }
        i{
          background: rgba(255, 45, 43, .4);
          &::before{
            background: #ff2d2b;
          }
          &::after{
            background: #ff2d2b;
            height: 2.56rem;
          }
        }
        &::before{
          border:.106667rem solid #ff2d2b;
        }
      }
    }
  }
}
</style>
